import moment from 'moment';
import React, { PureComponent } from 'react';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';

import {
  Table,
  FormDetailsItem,
  FormDetailsLink,
} from '../../common/components';
import { BREAKDOWN_STATUSES, DATE_FORMAT } from '../../app/config/config';
import { getCar, deleteCar } from '../services/car.service';

const TABLE_CONFIG_WARRANTY = {
  columns: [
    {
      caption: 'Data od',
      dataField: 'dateFrom',
      sort: true,
    },
    {
      caption: 'Data do',
      dataField: 'dateTo',
      sort: true,
    },
    {
      caption: 'Pakiet',
      dataField: 'dictWarrantyType.name',
    },
  ],
  noItemsFoundText: 'Brak gwarancji dla samochodu',
  initialSort: {
    sortField: 'dateTo',
    sortDirection: 'asc',
  },
  filterFields: 'dateFrom,dateTo',
};

const TABLE_CONFIG_BREAKDOWN = {
  columns: [
    {
      caption: 'Data',
      dataField: 'createdAt',
      renderCell: (createdAt) => moment(createdAt).format(DATE_FORMAT),
      sort: true,
    },
    {
      caption: 'Miejscowość wystąpienia',
      dataField: 'incidentPlace',
    },
    {
      caption: 'Przebieg',
      dataField: 'mileage',
    },
    {
      caption: 'Status',
      dataField: 'status',
      renderCell: (status) => BREAKDOWN_STATUSES[status] || '',
    },
  ],
  noItemsFoundText: 'Brak awarii dla samochodu',
  initialSort: {
    sortField: 'createdAt',
    sortDirection: 'asc',
  },
  filterFields: 'incidentPlace',
};

class CarDetails extends PureComponent {
  state = {
    data: {},
    isLoading: true,
  };

  id = this.props.match.params.id;

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    const {
      match: { params },
    } = this.props;

    this.setState({
      isLoading: true,
    });

    const data = await getCar(params.id);

    this.setState({
      data,
      isLoading: false,
    });
  };

  addWarrantyToCar = () => {
    const { history } = this.props;

    history.push(`/warranty?car=${this.id}`);
  };

  onEdit = () => {
    const { history } = this.props;

    history.push(`/car-edit/${this.id}`);
  };

  onWarrantyRowClick = (ev) => {
    const { history } = this.props;
    const {
      currentTarget: { id },
    } = ev;

    history.push(`/warranty-details/${id}`);
  };

  onRemove = async () => {
    const { history } = this.props;

    if (window.confirm('Jesteś pewien, ze chcesz usunąć samochód?')) {
      await deleteCar(this.id);

      history.goBack();
    }
  };

  render() {
    const { isAdmin } = this.props;
    const { data, isLoading } = this.state;

    if (isLoading) {
      return null;
    }

    return (
      <>
        {/* TODO validate if car has active warranty and block option to change */}
        <div className="content">
          <div className="card-header border row no-gutters justify-content-between align-items-center py-2">
            Szczegóły samochodu
            {isAdmin && (
              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={this.onRemove}
                >
                  Usuń samochód
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-2"
                  onClick={this.onEdit}
                >
                  Edytuj samochód
                </button>
              </div>
            )}
          </div>
          <div className="card rounded-0 border-top-0">
            <div className="card-body">
              <FormDetailsItem label="VIN" value={`${_get(data, 'vin')}`} />
              <FormDetailsLink
                label="Firma"
                value={`${_get(data, 'company.name')} (NIP ${_get(
                  data,
                  'company.vatId',
                )})`}
                href={`/company-details/${_get(data, 'company.id')}`}
              />
              <FormDetailsItem
                label="Marka"
                value={_get(data, 'manufacturer.name')}
              />
              <FormDetailsItem label="Model" value={_get(data, 'model.name')} />
              <FormDetailsItem
                label="Rok produkcji"
                value={_get(data, 'year')}
              />
              <FormDetailsItem
                label="Rodzaj paliwa"
                value={_get(data, 'fuelType.name')}
              />
              <FormDetailsItem
                label="Pojemność"
                value={`${_get(data, 'engine')} cm3`}
              />
              <FormDetailsItem
                label="Moc"
                value={`${_get(data, 'power')} kW | ${(
                  _get(data, 'power') * 1.36
                ).toFixed(0)} KM`}
              />
              <FormDetailsItem label="Przebieg" value={_get(data, 'mileage')} />
              {_get(data, 'notes') && (
                <FormDetailsItem
                  label="Dodatkowe informacje"
                  value={_get(data, 'notes')}
                />
              )}
            </div>
          </div>
        </div>
        <div className="content">
          <div className="card-header border row no-gutters justify-content-between align-items-center py-2">
            Gwarancje samochodu
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.addWarrantyToCar}
            >
              Dodaj gwarancję
            </button>
          </div>
          <div className="card rounded-0 border-top-0">
            <div className="card-body">
              <Table
                config={TABLE_CONFIG_WARRANTY}
                items={_get(data, 'warranties', [])}
                isLoading={isLoading}
                onRowClick={this.onWarrantyRowClick}
                noBorders
              />
            </div>
          </div>
        </div>
        {isAdmin && (
          <div className="content">
            <div className="card-header border row no-gutters justify-content-between align-items-center py-2">
              Awarie samochodu
            </div>
            <div className="card rounded-0  border-top-0">
              <div className="card-body">
                <Table
                  config={TABLE_CONFIG_BREAKDOWN}
                  items={_get(data, 'breakdowns', [])}
                  isLoading={isLoading}
                  noBorders
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(CarDetails);
